export const VALUE_TO_CHECK_ORDER_MANAGEMENT = 'eBusiness-Order_Management-R';